<template lang="pug">
  b-container.container
    b-card.price-board.mt-1
      .img-height
        template(v-if="contain_neo")
          img.image-size.mb-2(src="@/assets/images/logo_desknetsneo_clear_background.png")
        template(v-if="contain_appsuite")
          img.image-size.mb-2(src="@/assets/images/logo_appsuite.png")
        template(v-if="contain_chatluck")
          img.image-size.mb-2(src="@/assets/images/logo_chatluck.png")
      b-row.font-smaller.mb-2
        b-col.text-align-left 初期費用
        b-col.text-align-right {{sum_initial_cost}}（税込）
      b-row.font-smaller.mb-2
        b-col.text-align-left 月額費用
        b-col.text-align-right {{sum_monthly_cost}}（税込）
</template>

<script>
export default {
  name: "ShowCloudPrice.vue",
  props: {
    value: { type: Object, required: false }
  },
  data () {
    return {
      // 金額表示する項目
      payment_details: this.returnPaymentDetails()
    }
  },
  computed: {
    // 初期費用の金額の合計を計算する
    sum_initial_cost () {
      return this.getSumPrice('init')
    },
    // 月額費用の金額の合計を計算する
    sum_monthly_cost () {
      return this.getSumPrice('monthly')
    },
    // desknet's NEOを含む申請かどうか
    contain_neo () {
      return ['light', 'standard', 'premium', 'chatplus'].indexOf(this.value.plan_name) !== -1;
    },
    // AppSuiteを含む申請かどうか
    contain_appsuite () {
      return ['standard', 'premium'].indexOf(this.value.plan_name) !== -1;
    },
    // ChatLuckを含む申請かどうか
    contain_chatluck () {
      return ['premium', 'chatplus', 'chatluck'].indexOf(this.value.plan_name) !== -1;
    },
  },
  methods: {
    // 数値を生成する
    getSumPrice (cost_type) {
      // 初期化
      let sum_price = 0
      // プラン
      // ライトプランの場合
      if (this.value.plan_name === 'light') {
        this.payment_details.light.count = this.value.plan_user
      }
      // スタンダードプランの場合
      if (this.value.plan_name === 'standard') {
        this.payment_details.standard.count = this.value.plan_user
      }
      // プレミアムプランの場合
      if (this.value.plan_name === 'premium') {
        this.payment_details.premium.count = this.value.plan_user
      }
      // チャットプラスプランの場合
      if (this.value.plan_name === 'chatplus') {
        this.payment_details.chatplus.count = this.value.plan_user
      }
      // ChatLuckの場合
      if (this.value.plan_name === 'chatluck') {
        this.payment_details.chat_user.count = this.value.plan_user
      }

      // NEO
      if (this.contain_neo) {
        // AppSuiteを含まないプランの場合
        if (['light', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
          // AppSuiteユーザー数
          this.payment_details.app_suite_user.count = this.value.app_suite_user
        }
        // ウェブ会議
        this.payment_details.web_conferencing.count = this.value.web_conferencing

        // NEO オプションサービスが選択されている
        if (this.value.option_service === true) {
          // RoomMgr
          this.payment_details.room_mgr.count = this.value.option_room_mgr ? 1 : 0
          // 交通費・経費精算
          this.payment_details.expense_settlement.count = this.value.option_expense_settlement ? this.value.plan_user : 0
          // タイムカード + CLOUZA
          this.payment_details.clouza.count = this.value.clouza_check ? this.value.clouza_input / 10 : 0
          // 有休管理 + 申請承認オプション
          this.payment_details.clouza.monthly_unit_cost = this.value.paid_leave_option ? 2200 + 1650 : 2200
          // ディスク増設
          this.payment_details.neo_disk_size.count = this.value.option_disk ? this.value.option_disk_size : 0
          // Sync for smartphones
          this.payment_details.sync.count = this.value.option_sync ? this.value.option_sync_input : 0
          // desknet'sドライブ ディスク増設
          this.payment_details.dn_drive_disk_size.count = this.value.option_dn_drive ? this.value.option_dn_drive_disk_size : 0
        }
        // オプションサービスのチェックが外れた場合、初期値にする
        else {
          // RoomMgr
          this.payment_details.room_mgr.count = 0
          // 交通費・経費精算
          this.payment_details.expense_settlement.count = 0
          // タイムカード + CLOUZA
          this.payment_details.clouza.count = 0
          // ディスク増設
          this.payment_details.neo_disk_size.count = 0
          // Sync for smartphones
          this.payment_details.sync.count = 0
          // desknet'sドライブ ディスク増設
          this.payment_details.dn_drive_disk_size.count = 0
        }

        // NEO セキュリティオプション
        if (this.value.security_option) {
          // セキュアブラウザ
          if (this.value.secure_browser) {
            // セキュアブラウザ端末認証なしの場合
            if (this.value.secure_browser_terminal === '01') {
              // desknet'sNEOユーザ数を格納する
              this.payment_details.secure_browser_terminal_off.count = this.value.plan_user
              this.payment_details.secure_browser_terminal_on.count = 0
            }
            // セキュアブラウザ端末認証ありの場合
            else if (this.value.secure_browser_terminal === '02') {
              // セキュアブラウザデバイス数を格納する
              this.payment_details.secure_browser_terminal_off.count = 0
              this.payment_details.secure_browser_terminal_on.count = this.value.secure_browser_device
            }
          }
          // セキュアブラウザのチェックが外れた場合、初期値にする
          else {
            this.payment_details.secure_browser_terminal_off.count = 0
            this.payment_details.secure_browser_terminal_on.count = 0
          }
          // クライアント認証
          this.payment_details.client_auth.count = this.value.client_auth ? this.value.client_auth_input : 0
        }
        // セキュリティオプションのチェックが外れた場合、初期値にする
        else {
          // セキュアブラウザ
          this.payment_details.secure_browser_terminal_off.count = 0
          this.payment_details.secure_browser_terminal_on.count = 0
          // クライアント認証
          this.payment_details.client_auth.count = 0
        }

        // NEO メール
        if (this.value.mail_service) {
          // メールサービス（WebARENA）
          this.payment_details.web_arena.count = this.value.web_arena ? this.value.web_arena_input : 0
          // メールサービス（CYBERMAILΣ）
          if (this.value.cyber) {
            // ユーザー数
            // メールボックス容量が選択されたら、ユーザ数を計算する
            if (this.value.cyber_capacity !== '00') {
              this.payment_details.cyber_account.count = this.value.cyber_input
            }
            // メールボックス容量が選択されなかったら、ユーザ数の計算をしない
            else {
              this.payment_details.cyber_account.count = 0
            }
            // 単価は容量によって変わる
            switch (this.value.cyber_capacity) {
              case '02':
                this.payment_details.cyber_account.monthly_unit_cost = 275
                break
              case '03':
                this.payment_details.cyber_account.monthly_unit_cost = 440
                break
              case '04':
                this.payment_details.cyber_account.monthly_unit_cost = 550
                break
              default:
                this.payment_details.cyber_account.monthly_unit_cost = 220
            }
            // 情報漏えい対策
            this.payment_details.cyber_dlp.count = this.value.cyber_option[0] ? this.value.cyber_input : 0
            // 添付ファイル暗号化・分離
            this.payment_details.cyber_dlp_separation.count = this.value.cyber_option[1] ? this.value.cyber_input : 0
            // メールアーカイブ＆監査
            if (this.value.cyber_option[2] === true) {
              // 数量
              // 保存期間が選択されたら、数量を計算する
              if (this.value.cyber_keep_period !== '00') {
                this.payment_details.cyber_archive.count = this.value.cyber_input
              }
              // 保存期間が選択されなかったら、数量を計算しない
              else {
                this.payment_details.cyber_archive.count = 0
              }
              // 単価は保存期間によって変わる
              switch (this.value.cyber_keep_period) {
                case '02':
                  this.payment_details.cyber_archive.monthly_unit_cost = 440
                  break
                default:
                  this.payment_details.cyber_archive.monthly_unit_cost = 330
              }
            }
            // メールアーカイブ＆監査のチェックボックスが外れた場合、初期値にする
            else {
              this.payment_details.cyber_archive.count = 0
            }
            // クラウド型サンドボックス
            this.payment_details.cyber_sandbox.count = this.value.cyber_option[3] ? this.value.cyber_input : 0
          }
          // CYBERMAILのチェックが外れた場合、初期値にする
          else {
            // メールサービス（CYBERMAILΣ）
            this.payment_details.cyber_account.count = 0
            // 情報漏えい対策
            this.payment_details.cyber_dlp.count = 0
            // 添付ファイル暗号化・分離
            this.payment_details.cyber_dlp_separation.count = 0
            // メールアーカイブ＆監査
            this.payment_details.cyber_archive.count = 0
            // クラウド型サンドボックス
            this.payment_details.cyber_sandbox.count = 0
          }
        }
        // メールサービスのチェックが外れた場合、初期値にする
        else {
          // メールサービス（WebARENA）
          this.payment_details.web_arena.count = 0
          // メールサービス（CYBERMAILΣ）
          this.payment_details.cyber_account.count = 0
          // 情報漏えい対策
          this.payment_details.cyber_dlp.count = 0
          // 添付ファイル暗号化・分離
          this.payment_details.cyber_dlp_separation.count = 0
          // メールアーカイブ＆監査
          this.payment_details.cyber_archive.count = 0
          // クラウド型サンドボックス
          this.payment_details.cyber_sandbox.count = 0
        }

        // NEO メールセキュリティ
        if (this.value.mail_security_service) {
          // メールセキュリティサービス（MAILGATES Σ）
          if (this.value.mailgates) {
            // 初期費用
            this.payment_details.mailgates_init.count = 1
            // アンチウイルス・スパム＋サンドボックス
            this.payment_details.mailgates_antivirus_sandbox.count = this.value.mailgates_option[0] ? this.value.mailgates_input : 0
            // 誤送信対策・審査
            this.payment_details.mailgates_prevent_missend.count = this.value.mailgates_option[1] ? this.value.mailgates_input : 0
            // 添付ファイル暗号化・分離
            this.payment_details.mailgates_separation.count = this.value.mailgates_option[2] ? this.value.mailgates_input : 0
          }
          // MAILGATESのチェックが外れた場合、初期値にする
          else {
            // 初期費用
            this.payment_details.mailgates_init.count = 0
            // アンチウイルス・スパム＋サンドボックス
            this.payment_details.mailgates_antivirus_sandbox.count = 0
            // 誤送信対策・審査
            this.payment_details.mailgates_prevent_missend.count = 0
            // 添付ファイル暗号化・分離
            this.payment_details.mailgates_separation.count = 0
          }
        }
        // メールサービスのチェックが外れた場合、初期値にする
        else {
          // 初期費用
          this.payment_details.mailgates_init.count = 0
          // アンチウイルス・スパム＋サンドボックス
          this.payment_details.mailgates_antivirus_sandbox.count = 0
          // 誤送信対策・審査
          this.payment_details.mailgates_prevent_missend.count = 0
          // 添付ファイル暗号化・分離
          this.payment_details.mailgates_separation.count = 0
        }
      }

      // ChatLuckユーザ数
      if (this.contain_chatluck) {
        // ディスク増設
        if (this.value.chat_option_service && this.value.chat_option_disk) {
          this.payment_details.chat_disk_size.count = this.value.chat_option_disk_size
        }
        else {
          this.payment_details.chat_disk_size.count = 0
        }
      }

      // 初期費用の合計を取得する
      if (cost_type === 'init') {
        sum_price = this.sumInitialCost()
      }
      // 月額費用の合計を取得する
      else if (cost_type === 'monthly') {
        sum_price = this.sumMonthlyCost()
      }

      // 合計金額を表示する文字列を作成する
      return this.getSumCostString(sum_price)
    },

    // 選択されている注文を取得する
    active_payment_details() {
      const selectedItems = [];

      // 各キーに対して繰り返し処理を行う
      for (let key in this.payment_details) {
        // 選択されている商品のみを表示する
        if (this.payment_details[key].count > 0) {
          // 配列に追加する
          selectedItems.push(this.payment_details[key]);
        }
      }

      // 選択されている商品を返す
      return selectedItems;
    },

    // 初期費用の合計
    sumInitialCost() {
      let sum_cost = 0
      // プランにdesknet's NEOのみ含まれている場合
      if (['light', 'standard'].indexOf(this.value.plan_name) !== -1) {
        for (let detail of this.active_payment_details()) {
          // NEOのみを集計対象とする かつ お見積番号が入力されている場合は加算しない
          sum_cost += ((detail.type === 'neo' || detail.type === "plan") && this.value.estimate) ? 0 : detail.initial_cost
        }
      }

      // プランにdesknet's NEOとChatLuckが含まれている場合
      if (['premium', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
        for (let detail of this.active_payment_details()) {
          // お見積番号が入力されている場合は加算しない
          sum_cost += (this.value.estimate) ? 0 : detail.initial_cost
        }
      }

      // プランにChatLuckのみ含まれている場合
      if (['chatluck'].indexOf(this.value.plan_name) !== -1) {
        for (let detail of this.active_payment_details()) {
          // NEOのみを集計対象とする かつ お見積番号が入力されている場合は加算しない
          sum_cost += ((detail.type === 'chat' || detail.type === "plan") && this.value.estimate) ? 0 : detail.initial_cost
        }
      }

      // 初期費用の合計金額を返す
      return sum_cost
    },

    // 月額費用の合計
    sumMonthlyCost() {
      let sum_cost = 0

      // プランにdesknet's NEOのみ含まれている場合
      if (['light', 'standard'].indexOf(this.value.plan_name) !== -1) {
        for (let detail of this.active_payment_details()) {
          // NEOのみを集計対象とする かつ お見積番号が入力されている場合は加算しない
          sum_cost += ((detail.type === 'neo' || detail.type === "plan") && this.value.estimate) ? 0 : detail.monthly_unit_cost * detail.count
        }
      }

      // プランにdesknet's NEOとChatLuckが含まれている場合
      if (['premium', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
        for (let detail of this.active_payment_details()) {
          // お見積番号が入力されている場合は加算しない
          sum_cost += (this.value.estimate) ? 0 : detail.monthly_unit_cost * detail.count
        }
      }

      // プランにChatLuckのみ含まれている場合
      if (['chatluck'].indexOf(this.value.plan_name) !== -1) {
        for (let detail of this.active_payment_details()) {
          // NEOのみを集計対象とする かつ お見積番号が入力されている場合は加算しない
          sum_cost += ((detail.type === 'chat' || detail.type === "plan") && this.value.estimate) ? 0 : detail.monthly_unit_cost * detail.count
        }
      }

      // 月額費用の合計金額を返す
      return sum_cost
    },

    // 合計金額を表示する文字列を生成する
    getSumCostString(sumCost) {
      // 0円になる場合は「- -」で表示する
      let showCost = '- -'
      if (sumCost > 0) {
        showCost = this.showPriceNumber(sumCost)
      }

      // 合計金額を表示する文字列を返す
      return showCost
    }
  },
}
</script>

<style scoped>
.image-size {
  width: 120px;
  height: auto;
}
.font-smaller {
  font-size: 75%;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
  white-space: nowrap;
}
.img-height {
  height: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.img-height img {
  margin: 0 auto;
}
.price-board {
  position: sticky;
  top: 0;
  background: #efefef;
  border-radius: 20%;
  border: 0;
}
</style>